import { InternalErrorComponent } from './internal-error.component';
import { CommonModule } from '@angular/common';

import { Route, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Route[] = [
  {
    path: 'internal-error',
    pathMatch: 'full',
    component: InternalErrorComponent,
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
})
export class InternalErrorModule {}
